module.exports = __webpack_public_path__ + "img/card.50ae72a7.svg";